<template>
  <div>
    <v-dialog scrollable v-model="dialogs.edit" persistent max-width="500px">
      <material-card
        v-if="insuranceCarrier!==null && insuranceCarrier!==undefined"
        :title="formTitle"
        :icon="formIcon"
        :color="formColor"
      >
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-container fluid grid-list-md>
              <v-row>
                <v-col xs="12">
                  <trans-textbox
                    v-model="insuranceCarrier"
                    :label="$t('globals.name')"
                    :rules="[$rules.required]"
                    field="Name"
                    class="required"
                  ></trans-textbox>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="close()">{{$t('globals.cancel')}}</v-btn>
          <v-btn
            :disabled="!valid"
            color="primary"
            :loading="saving"
            @click="save"
          >{{$t('globals.save')}}</v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="dialogs.delete"
      persistent
      max-width="400"
    >
      <material-card v-if="insuranceCarrier" :title="$t('views.insurancecarriersindex.delete_insurance_carrier_{0}',  [trans(insuranceCarrier, 'Name')])" :color="$vuetify.theme.themes.light.error" icon="delete">
        <v-card-text>{{ $t("globals.are_you_sure") }}</v-card-text>
        <v-card-actions>
          <v-btn color text @click="dialogs.delete = false">{{
            $t("Cancel")
          }}</v-btn>
          <v-btn color="error" text @click="deleteItem">{{
            $t("globals.delete")
          }}</v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <material-card
    :title="$t('globals.insurance_carriers')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="home_work"
    >
      <pbas-data-table
        ref="table"
        :dataProvider="provider"
        :rowActions="rowActions"
        :floatActions="floatActions"
        fileNamePrefix="insurance-carriers-index"
        @itemsChanged="setData($event)"
        :exporters="$exporters"
        identifier="insuranceCarriersIndexTable"
        sortBy="Name"
        @error="error=$event"
      ></pbas-data-table>
    </material-card>
    <v-snackbar
      v-model="snackbar"
      :color="color"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
      :vertical="mode === 'vertical'"
    >
      {{ $t(message) }}
      <v-btn dark text @click="snackbar = false">{{ $t("globals.close") }}</v-btn>
    </v-snackbar>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import TransTextbox from "../components/TransTextbox";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import InsuranceCarriersIndexHeaders from "../headers/InsuranceCarriersIndex";
import { locker } from "../mixins/locker";
import { translate2 } from "../trans2";

export default {
  name: "insurance-carriers-index",
  components: {
    ErrorHandler,
    TransTextbox
  },
  mixins: [locker],
  data() {
    return {
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      valid: true,
      provider: undefined,
      saving: false,
      floatActions: [
        {
          name: "add",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: () => this.editItem(this.defaultItem)
        }
      ],
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: item => this.editItem(item)
        },
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: item => {
            this.insuranceCarrier = item;
            this.dialogs.delete = true;
          }
        }
      ],
      dialogs: {
        edit: false,
        delete: false
      },
      insuranceCarriers: [],
      headers: InsuranceCarriersIndexHeaders,
      editedIndex: -1,
      insuranceCarrier: null,
      defaultItem: {},
      error: null
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
    formTitle() {
      let name ="";
      if (this.editedIndex > -1 && this.insuranceCarrier.Translations.filter(o=>o.LanguageCode===this.language.language).length > 0) {
        name = this.insuranceCarrier.Translations.filter(o=>o.LanguageCode===this.language.language)[0].Name;
      }
      else {
        name = this.insuranceCarrier.Name;
      }
      // console.log(this.insuranceCarrier, name);
      return this.editedIndex === -1 ? this.$t("views.insurancecarriersindex.new") : this.$t("views.insurancecarriersindex.edit_{0}", [name]);
    },
    formIcon() {
      return this.editedIndex === -1 ? "add" : "edit";
    },
    formColor() {
      return this.editedIndex === -1 ? this.$vuetify.theme.themes.light.success : this.$vuetify.theme.themes.light.primary;
    },
    url: function() {
      return "insuranceCarriersIndex";
    }
  },
  mounted() {
    this.provider = new PbasOData(this.$axiosHttp, this.url, this.headers);
  },
  methods: {
    ...mapActions("plansMembers", [
      "addInsuranceCarrier",
      "updateInsuranceCarrierIndex",
      "getInsuranceCarrierIndex",
      "deleteInsuranceCarrierIndex",
    ]),
    trans(item, field) {
      return translate2(item, field);
    },
    setData(items) {
      //console.log(items);
      this.insuranceCarriers = items;
    },
    async editItem(item) {
      const editedIndex = this.insuranceCarriers.indexOf(item);
      //console.log(editedIndex)
      if (editedIndex > -1) {
        try {
          this.insuranceCarrier = await this.lock(
            this.getInsuranceCarrierIndex,
            {
              plan:null,
              id: item.Id,
              dialogs: this.dialogs,
              dialog: "edit"
            },
            () => {
              this.dialogs.edit = false;
            }
          );
          if (!this.insuranceCarrier.Address) this.insuranceCarrier.Address = {};
          //console.log(this.insuranceCarrier);
          this.dialogs.edit = true;
          this.editedIndex = editedIndex;
        } catch (error) {
          this.error = error;
        }
      } else {
        this.insuranceCarrier = JSON.parse(JSON.stringify(item));
        this.dialogs.edit = true;
          this.editedIndex = editedIndex;
      }
    },
    async deleteItem() {
      try {
        this.saving = true;
        await this.deleteInsuranceCarrierIndex({
          id: this.insuranceCarrier.Id
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.dialogs.delete = false;
        await this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    close() {
      this.dialogs.edit = false;
      this.insuranceCarrier = JSON.parse(JSON.stringify(this.defaultItem));
      this.editedIndex = -1;
    },
    save() {
      let item = JSON.parse(JSON.stringify(this.insuranceCarrier));
      item.Name = item.Translations.filter(o=>o.LanguageCode===this.language.language)[0].Name;
      if (this.editedIndex > -1) {
        this.update(item);
      } else {
        this.add(item);
      }
    },
    async update(item) {
      this.saving = true;
      try {
        await this.updateInsuranceCarrierIndex({
          id: item.Id,
          payload: item
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.close();
        this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async add(item) {
      this.saving = true;
      try {
        await this.addInsuranceCarrier(item);
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.close();
        this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
  }
};
</script>
